(function () {
  'use strict';

  var STORAGE_KEY = 'shopify_wishlist';

  // ─── Storage Helpers ───────────────────────────────────
  // Stores items as [{id: "123", handle: "product-name"}, ...]

  function getWishlist() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      // Backward compat: migrate if old format (plain string IDs)
      if (raw.length > 0 && typeof raw[0] === 'string') {
        return [];
      }
      return raw;
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isInWishlist(productId) {
    var id = String(productId);
    return getWishlist().some(function (item) { return String(item.id) === id; });
  }

  function addToWishlist(productId, productHandle) {
    var list = getWishlist();
    var id = String(productId);
    var exists = list.some(function (item) { return String(item.id) === id; });
    if (!exists && productHandle) {
      list.push({ id: id, handle: String(productHandle) });
      saveWishlist(list);
    }
  }

  function removeFromWishlist(productId) {
    var list = getWishlist();
    var id = String(productId);
    var filtered = list.filter(function (item) { return String(item.id) !== id; });
    saveWishlist(filtered);
  }

  // ─── Toast Notification ────────────────────────────────

  function showToast(message) {
    var existing = document.querySelector('.wishlist-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'wishlist-toast';
    toast.textContent = message;
    document.body.appendChild(toast);

    // Trigger reflow for animation
    toast.offsetHeight;
    toast.classList.add('wishlist-toast--visible');

    setTimeout(function () {
      toast.classList.remove('wishlist-toast--visible');
      setTimeout(function () {
        toast.remove();
      }, 300);
    }, 2500);
  }

  // ─── Update Badge Count ────────────────────────────────

  function updateBadge() {
    var count = getWishlist().length;
    var badges = document.querySelectorAll('.wishlist-count-badge');
    badges.forEach(function (badge) {
      if (count > 0) {
        badge.textContent = count;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  // ─── Update Active States on All Buttons ───────────────

  function updateAllButtons() {
    // Product card icons
    document.querySelectorAll('.wishlist-icon[data-product-id]').forEach(function (el) {
      var id = el.getAttribute('data-product-id');
      if (isInWishlist(id)) {
        el.classList.add('wishlist-active');
      } else {
        el.classList.remove('wishlist-active');
      }
    });

    // Product page button
    document.querySelectorAll('.product-wishlist[data-product-id]').forEach(function (el) {
      var id = el.getAttribute('data-product-id');
      if (isInWishlist(id)) {
        el.classList.add('wishlist-active');
        var textEl = el.querySelector('.wishlist-btn-text');
        if (textEl) textEl.textContent = 'Remove from Wishlist';
      } else {
        el.classList.remove('wishlist-active');
        var textEl = el.querySelector('.wishlist-btn-text');
        if (textEl) textEl.textContent = 'Add to Wishlist';
      }
    });
  }

  // ─── Click Handlers ────────────────────────────────────

  function handleWishlistClick(e) {
    var target = e.target.closest('.wishlist-icon[data-product-id], .product-wishlist[data-product-id]');
    if (!target) return;

    e.preventDefault();
    e.stopPropagation();

    var productId = target.getAttribute('data-product-id');
    var productHandle = target.getAttribute('data-product-handle');
    if (!productId) return;

    if (isInWishlist(productId)) {
      removeFromWishlist(productId);
      showToast('Removed from wishlist');
    } else {
      if (!productHandle) return;
      addToWishlist(productId, productHandle);
      showToast('Added to wishlist');
    }

    updateAllButtons();
    updateBadge();

    // If on wishlist page, re-render
    if (document.querySelector('.wishlist-page')) {
      renderWishlistPage();
    }
  }

  // ─── Format Price ──────────────────────────────────────

  function formatMoney(price) {
    var amount = parseFloat(price);
    if (isNaN(amount)) return '';
    try {
      var currencyCode = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'GBP';
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currencyCode
      }).format(amount);
    } catch (e) {
      return price;
    }
  }

  // ─── Wishlist Page Rendering ───────────────────────────

  function renderWishlistPage() {
    var container = document.querySelector('.wishlist-page-grid');
    var emptyState = document.querySelector('.wishlist-empty');
    if (!container) return;

    var wishlist = getWishlist();

    if (wishlist.length === 0) {
      container.innerHTML = '';
      if (emptyState) emptyState.style.display = 'block';
      return;
    }

    if (emptyState) emptyState.style.display = 'none';
    container.innerHTML = '<div class="wishlist-loading">Loading your wishlist...</div>';

    // Fetch each product individually by handle
    var fetches = wishlist.map(function (item) {
      return fetch('/products/' + item.handle + '.json')
        .then(function (r) {
          if (!r.ok) return null;
          return r.json();
        })
        .then(function (data) {
          return data && data.product ? data.product : null;
        })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (products) {
      var validProducts = products.filter(Boolean);

      if (validProducts.length === 0) {
        container.innerHTML = '';
        if (emptyState) emptyState.style.display = 'block';
        return;
      }

      var html = '';
      validProducts.forEach(function (product) {
        var image = '';
        if (product.image && product.image.src) {
          image = product.image.src;
        } else if (product.images && product.images.length > 0) {
          image = product.images[0].src;
        }

        // Price from /products/{handle}.json is already in decimal (e.g. "29.99")
        var price = product.variants && product.variants[0] ? product.variants[0].price : '0.00';
        var comparePrice = product.variants && product.variants[0] ? product.variants[0].compare_at_price : null;
        var url = '/products/' + product.handle;

        html += '<div class="product-cart-main wishlist-product-card" data-product-id="' + product.id + '">';
        html += '  <div class="product-header-img">';
        html += '    <div class="product-header-top-info">';
        html += '      <span></span>';
        html += '      <span class="wishlist-icon wishlist-active" data-product-id="' + product.id + '" data-product-handle="' + product.handle + '">';
        html += '        <svg class="wishlist-heart-outline" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">';
        html += '          <path d="M5.93439 18.5443L15.3155 27.3569C15.6399 27.6616 15.8021 27.814 16.0002 27.814C16.1982 27.814 16.3604 27.6616 16.6848 27.3569L26.0659 18.5443C28.6742 16.0942 28.9909 12.0622 26.7972 9.2348L26.3848 8.70316C23.7605 5.32081 18.493 5.88806 16.6491 9.75157C16.3886 10.2973 15.6117 10.2973 15.3513 9.75157C13.5073 5.88806 8.23979 5.32081 5.61556 8.70316L5.20308 9.2348C3.00943 12.0622 3.32616 16.0942 5.93439 18.5443Z" stroke="#A9A9A9" stroke-width="1.4"/>';
        html += '        </svg>';
        html += '        <svg class="wishlist-heart-filled" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">';
        html += '          <path d="M5.93439 18.5443L15.3155 27.3569C15.6399 27.6616 15.8021 27.814 16.0002 27.814C16.1982 27.814 16.3604 27.6616 16.6848 27.3569L26.0659 18.5443C28.6742 16.0942 28.9909 12.0622 26.7972 9.2348L26.3848 8.70316C23.7605 5.32081 18.493 5.88806 16.6491 9.75157C16.3886 10.2973 15.6117 10.2973 15.3513 9.75157C13.5073 5.88806 8.23979 5.32081 5.61556 8.70316L5.20308 9.2348C3.00943 12.0622 3.32616 16.0942 5.93439 18.5443Z" fill="#E53E3E" stroke="#E53E3E" stroke-width="1.4"/>';
        html += '        </svg>';
        html += '      </span>';
        html += '    </div>';
        html += '    <a href="' + url + '">';
        html += '      <img src="' + image + '" alt="' + product.title + '">';
        html += '    </a>';
        html += '    <a href="' + url + '" class="cart-btn">ADD TO CART';
        html += '      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">';
        html += '        <path d="M6.93514 18.459C6.93514 17.6018 6.25567 16.9079 5.42631 16.9079C4.58697 16.9079 3.9075 17.6018 3.9075 18.459C3.9075 19.3061 4.58697 20 5.42631 20C6.25567 20 6.93514 19.3061 6.93514 18.459Z" fill="#080808"/>';
        html += '        <path d="M18.1764 18.459C18.1764 17.6018 17.4969 16.9079 16.6676 16.9079C15.8282 16.9079 15.1487 17.6018 15.1487 18.459C15.1487 19.3061 15.8282 20 16.6676 20C17.4969 20 18.1764 19.3061 18.1764 18.459Z" fill="#080808"/>';
        html += '        <path d="M0.880056 0.0087383L3.2632 0.375101C3.60293 0.437352 3.85274 0.722074 3.88272 1.06905L4.07257 3.35499C4.10254 3.68257 4.36234 3.92749 4.68209 3.92749H18.1766C18.7861 3.92749 19.1858 4.1418 19.5855 4.61123C19.9852 5.08067 20.0551 5.7542 19.9652 6.36549L19.0159 13.06C18.8361 14.3469 17.7569 15.2949 16.4879 15.2949H5.58639C4.25742 15.2949 3.15828 14.255 3.04837 12.908L2.12908 1.7834L0.620259 1.51807C0.22057 1.44664 -0.0592117 1.04864 0.0107338 0.640433C0.0748505 0.257828 0.407647 -0.00644177 0.778226 0.00011949C0.811915 0.000715967 0.845916 0.00355071 0.880056 0.0087383Z" fill="#080808"/>';
        html += '      </svg>';
        html += '    </a>';
        html += '  </div>';
        html += '  <a href="' + url + '" style="text-decoration: none;"><h3>' + product.title + '</h3></a>';
        html += '  <div class="product-price">';
        if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
          html += '    <span class="original-price">' + formatMoney(comparePrice) + '</span>';
        }
        html += '    <span class="current-price">' + formatMoney(price) + '</span>';
        html += '  </div>';
        html += '</div>';
      });

      container.innerHTML = html;
    });
  }

  // ─── Initialize ────────────────────────────────────────

  function init() {
    // Attach click handler via delegation
    document.addEventListener('click', handleWishlistClick);

    // Set initial active states
    updateAllButtons();
    updateBadge();

    // Render wishlist page if on that page
    if (document.querySelector('.wishlist-page')) {
      renderWishlistPage();
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for external use
  window.Wishlist = {
    get: getWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    isIn: isInWishlist,
    updateUI: function () {
      updateAllButtons();
      updateBadge();
    }
  };
})();
